import React, {useState, useEffect} from "react";
import {connect} from 'react-redux';
import Select from "react-select";
import {alertActions} from "../../../../redux/actions/alert-actions";
import {listService} from "../../../../services/lists";
import {brandService} from "../../../../services/brand";

function BrandDataDuplicateForm(props) {

    const [filters_list, setFilters] = useState([]);
    const [duplicate_filters, setRecords] = useState([]);
    const [product_filter_cols, setSearchable] = useState([]);
    const [quantity_attributes, setQuantityAttributes] = useState([]);
    const [duplicate_confirmed, setDuplicateConfirm] = useState(false);
    const [show_confirm_button, setConfirmButton] = useState(false);
    const [duplicate_message, setMessage] = useState('');


    async function getFiltersList() {
        try {
            const res = await listService.getList('Product Filters', "", "", "", "", "product_filter", false);
            setFilters(res.result.list_type_listing.data);
        } catch (e) {
            console.log('Error in listing', e);
        }
    }

    async function duplicateProducts(e, confirm = false) {
        e.preventDefault();
        try {
            let data = {
                brand_short_code: props.brand.short_code,
                duplicate_filters: duplicate_filters.map(item => item.title),
                product_filter_val: props.product_filter_val,
                product_ids: props.product_ids.length > 0 ? props.product_ids.split(',') : [],
                product_filter_cols: props.product_filter_val ? product_filter_cols : null,
                quantity_attributes,
                duplicate_confirmed: confirm,
                duplicate_records_count: 0
            }
            const duplicate_res = await brandService.duplicateProducts(data);
            setMessage(duplicate_res.message);
            if (show_confirm_button) {
                props.return_submitted_data({duplicated: true});
                props.successAlert(duplicate_res.message);
                props.closeModel();
            } else {
                setConfirmButton(true);
            }
            setDuplicateConfirm(true);
        } catch (e) {
            setConfirmButton(true);
            props.errorAlert(e);
            console.log('Error while duplicating', e);
        }
    }

    const onFilterSelect = (value) => {
        if (value.length > 0) {
            setRecords(value);
        } else {
            setRecords([]);
        }
    }
    useEffect(() => {
        getFiltersList();
    }, []);

    useEffect(() => {
        let searchable = [];
        let quantity_atts = [];
        if (Object.keys(props.brand).length > 0) {
            let product_attributes = Object.values(props.brand.product_attributes);
            product_attributes.forEach(prod => {
                if (prod.searchable) {
                    searchable.push(prod.db_column);
                }
                if (prod.is_quantity_attribute) {
                    quantity_atts.push(prod.db_column)
                }
            })
        }
        setQuantityAttributes(quantity_atts);
        setSearchable(searchable);
        console.log(props.brand.product_attributes);
    }, [props.brand]);

    const cancelDuplication = (e) => {
        e.preventDefault();
        setMessage('');
        setRecords([]);
        setConfirmButton(false);
    }

    return (
        <form onSubmit={duplicateProducts}>
            <div className="row">
                <div className="col-md-12 mb-xlg">
                    <div className="mt-xlg text-center">
                        <div>
                            <Select
                                value={duplicate_filters}
                                onChange={onFilterSelect}
                                getOptionLabel={(option) => option.title}
                                getOptionValue={(option) => option.id}
                                options={filters_list}
                                isSearchable={true}
                                isClearable={true}
                                name={'duplicate_records'}
                                isMulti={true}
                                isDisabled={show_confirm_button}
                                placeholder={'Choose Filter'}
                            />
                        </div>
                        <div style={{
                            marginTop: '50px',
                        }}>
                            {duplicate_message}
                        </div>
                        {
                            show_confirm_button ?
                                <React.Fragment>
                                    <div style={{
                                        marginTop: '50px',
                                    }}>
                                        <button className="customBtn"
                                                style={{
                                                    maxWidth: '120px',
                                                    marginTop: '10px',
                                                    marginRight: '15px',
                                                    backgroundColor: 'black'
                                                }}
                                                onClick={(e) => {
                                                    duplicateProducts(e, true)
                                                }}
                                        >
                                            Confirm
                                        </button>
                                        <button className="customBtn"
                                                style={{
                                                    maxWidth: '120px',
                                                    marginTop: '10px',
                                                    marginRight: '15px',
                                                    backgroundColor: 'tomato'
                                                }}
                                                type="button"
                                                onClick={cancelDuplication}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </React.Fragment>
                                :
                                <div style={{
                                    marginTop: '50px',
                                }}>
                                    <input
                                        type="submit"
                                        value="Duplicate"
                                        className="customBtn btnBlue"
                                        disabled={duplicate_filters.length < 1 ? true : false}
                                    />
                                </div>
                        }
                    </div>
                </div>
            </div>
        </form>
    );
}

const mapDispatchToProps = dispatch => {
    return ({
        errorAlert: (e) => {
            dispatch(alertActions.error(e))
        },
        successAlert: (msg) => {
            dispatch(alertActions.success(msg))
        },
    });
};

export default connect(null, mapDispatchToProps)(BrandDataDuplicateForm);



// WEBPACK FOOTER //
// ./src/components/Admin/Brands/Forms/BrandDataDuplicateForm.jsx